import { IconCustomMenuDown, IconX } from '../../icons/tabler';
import { Components, SvgIcon } from '../../material';

export const MuiAutocomplete: Components['MuiAutocomplete'] = {
  defaultProps: {
    ChipProps: {
      size: 'small',
    },
    slotProps: {
      paper: {
        elevation: 6,
      },
    },
    popupIcon: (
      <SvgIcon>
        <IconCustomMenuDown />
      </SvgIcon>
    ),
    clearIcon: (
      <SvgIcon fontSize="small">
        <IconX />
      </SvgIcon>
    ),
  },
};
